<script type="text/javascript" src="../js/jquery-3.2.1.min.js"></script>
<template>
<div id="app" oncontextmenu="return false" ondragstart="return false" onselectstart="return false">

    <div class="reser_head_content" v-bind:style="{backgroundImage: 'url(' + store_bg_image + ')', backgroundSize: '100%',display: header_style}">
        <div class="top_menu_bar" :style="{backgroundImage: 'url(' + store_top_image + ')', backgroundSize: '100%'}">
            <div id="header">
                <div class="header-wrap">
                    <h1 class="logo" @click="goHome">
                        <img src="./assets/image/logo_s.png" alt="logo">
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="reser_footer_content">
        <div v-if="login_chk == 1" class="bottom_menu_bar">
            <ul>
                <li class="bottom_menu_icon active">
                    <!-- <a @click="move_page(0)"> -->
                    <a @click="goBack()">
                        <div class='icon'>
                            <img src="./assets/image/bottom_home.png" alt="home">
                            <img class='img2' src="./assets/image/bottom_home_active.png" alt="home">
                        </div>
                        <div class='name'><span data-text="HOME"> HOME </span></div>
                    </a>
                </li>
                <li class="bottom_menu_icon">
                    <a @click="move_page(1)">
                        <div class='icon'>
                            <img src="./assets/image/bottom_seat.png" alt="seat">
                            <img class='img2' src="./assets/image/bottom_seat_active.png" alt="seat">
                        </div>
                        <div class='name'><span data-text="좌석선택"> 좌석선택 </span></div>
                    </a>
                </li>
                <li class="bottom_menu_icon">
                    <a @click="move_page(2)">
                        <div class='icon'>
                            <img src="./assets/image/bottom_barcode.png" alt="barcode">
                            <img class='img2' src="./assets/image/bottom_barcode_active.png" alt="barcode">
                        </div>
                        <!-- 260115 BAROCDE > BARCODE -->
                        <div class='name'><span data-text="BARCODE">BARCODE</span></div>
                    </a>
                </li>
                <li class="bottom_menu_icon">
                    <a @click="move_page(3)">
                        <div class='icon'>
                            <img src="./assets/image/bottom_goods_list.png" alt="goodslist">
                            <img class='img2' src="./assets/image/bottom_goods_list_active.png" alt="goodslist">
                        </div>
                        <div class='name'><span data-text="상품리스트">상품리스트</span></div>
                    </a>
                </li>
                <li class="bottom_menu_icon">
                    <a @click="move_page(4)">
                        <div class='icon'>
                            <img src="./assets/image/bottom_mypage.png" alt="mypage">
                            <img class='img2' src="./assets/image/bottom_mypage_active.png" alt="mypage">
                        </div>
                        <div class='name'><span data-text="마이페이지">마이페이지</span></div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <popup ref="pop_up"></popup>
    <router-view />

</div>
<!-- 연장기능 추가 -->
<!-- <button @click="extensionToken">연장</button> -->
</template>

<script>
import vue from 'vue';
import videoPlayer from './components/components/videoPlayer';
import popup from './components/components/pop';
import * as config from './javascript/config';
import { EventBus } from './main.js';

import external from '@/assets/js/external.js';

vue.component('popup', popup);
vue.component('videoPlayer', videoPlayer);
export default {
    name: 'App',
    data() {
        return {
            login_chk: 0,
            title: 'Timer',
            timer: null,
            total_time: 0,
            login_user: { name : '비회원' },
            date: new Date(),
            header_style : 'none',
            init_time : 0,
            nomal_init_time : 0,
            nomal_timer : null,
            nomal_total_time: 0,
            top_menu_list : [],
            store_bg_image: '',
            store_top_image: '',
            text_color : '',

            store_name:'',
            user_name:'',
            now_route: 0,
            // 코드 추가 - 2020-12-23
            promotion_yn: this.$store.state.mobile_promotion_yn.value
        }
    },
    created(){
        EventBus.$on('route_change', (num) => {
            this.now_route = num;
        });

        if (process.env.NODE_ENV == 'production') {
            // 로그인후 체크 시간
            this.init_time = 300;
            // 일반 사용자 10초 이벤트x (start 화면으로)
            this.nomal_init_time = 300;
            // 콘솔 메세지 안나오게
        }else{
            // 로그인후 체크 시간
            this.init_time = 1800;
            // 일반 사용자 10초 이벤트x (start 화면으로)
            this.nomal_init_time = 600;
        }
        this.onEverySecond();
    },
    methods: {
        goBack(){
          if(this.now_route == 0){
            window.close();
          } else {
            this.move_page(0);
          }
        },
        /* 삭제예정
        adv_close(){
            this.$store.commit('set_css_file_remove', {
                value: 'main_min_video'
            });
            this.$store.commit('set_css_file_remove', {
                value: 'video-js'
            });
        }, */
        change_store(){
            this.$router.push('/store');
        },
        check_items_status(Num) { // 상단 아이콘이 눌렸을때 , 이전에 셋팅되어있던 item(좌석/사물함/그룹룸) 의 상태값을 체크
            var status_chk = this.$store.getters['getItem_update_check'];
            if(status_chk.last_status == 'lock'){
                const condition_type = config.REQ_UPDATE_AVAILABLE_STATUS;
                const condition_data = {
                    'item_id': status_chk.item_id,
                    'item': status_chk.item
                };
                this.$store.dispatch(condition_type.action_name, {
                    type: condition_type,
                    data: condition_data
                }).then(response => {
                    if(response.result){
                    // 상태 체크를 위한 데이터 셋팅
                    this.$store.commit('set_Item_update_check', {
                        item_id: '',
                        item: '',
                        last_status:''
                    });
                    }
                }).catch(function (error) {
                    console.log('error=============>', error);
                });
            }

            if(this.$store.getters['get_groom_reservation_pay']){
                this.$store.commit('set_groom_reservation_pay', false);
            }
            if(Num == 0 && this.$router.history.current.fullPath != '/front_main'){
                this.$router.push('/front_main');
            }else if(Num == 1 && this.$router.history.current.fullPath != '/'){
                this.$router.push('/');
            }else if(Num == 2 && this.$router.history.current.fullPath != '/'){
                this.$router.push('/');
            }else if(Num == 3 && this.$router.history.current.fullPath != '/price_list'){
                this.$router.push('/price_list');
            }else if(Num == 4 && this.$router.history.current.fullPath != '/mypage'){
                this.$router.push('/mypage');
            }else{
                // this.$router.push('/start');
            }

            this.now_route = Num;
        },
        logout() {
            this.$store.commit('user_logout', {
                value: 'logout'
            });
            this.$store.commit('set_price_page_tab_code', {
                'tab_code':''
            })
            this.$store.commit('set_page_header_init', {
                style: 'none'
            });
            this.$router.push('/start');
            this.check_items_status();
            this.$store.commit('set_reset_popup_type');
        },
        padTime: function (time) {
            return (time < 10 ? '0' : '') + time;
        },
        extensionToken: function () {
            var self = this;
            // 토큰 값
            const type = config.REQ_MEMBER_AUTH_REFRESH;
            const data = {
                data: {
                    'token_id': this.token_id
                }
            }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}
            this.$store.dispatch(type.action_name, {
                type: type,
                data: data
            }).then(function (response) {
                var result = response.result;
                if (result == "refresh") {
                    self.$store.commit('set_user_token', {
                        vo: response.token
                    });
                }
            }).catch(function (error) {
                console.log('error=============>', error);
            });
            this.resetTimer()
        },
        onEverySecond: function () {
            this.date = new Date()
            setTimeout(this.onEverySecond, 1000)
        },
        get_top_menu_list(tab_code){/*
            this.$store.commit('set_use_extend_flag', {
                'use_extend_flag':false
            })
            this.top_menu_list =[];
            var top_menu = {};
            top_menu.url = "/";
            top_menu.name = "좌석선택";
            top_menu.img = require("./assets/image/top_ico_01.png");
            if(tab_code == "CHOOSE"){top_menu.class = "on";}
            top_menu.router_yn = true;
            this.top_menu_list.push(top_menu);
            top_menu = {};
            top_menu.url = "/price_list";
            //top_menu.name = "상품구매";
            top_menu.name = "상품리스트";
            top_menu.img = require("./assets/image/top_ico_02.png");
            top_menu.router_yn = true;
            this.top_menu_list.push(top_menu);
            if(tab_code == "PRICE"){top_menu.class = "on";}
            top_menu = {};
            top_menu.url = "/mypage";
            top_menu.name = "마이페이지";
            top_menu.img = require("./assets/image/top_ico_03.png");
            top_menu.router_yn = true;
            this.top_menu_list.push(top_menu);
            if(tab_code == "MYPAGE"){top_menu.class = "on";}

            top_menu = {};
            top_menu.url = "#";
            top_menu.name = "로그아웃";
            top_menu.img = require("./assets/image/top_ico_04.png");
            top_menu.router_yn = false;
            this.top_menu_list.push(top_menu); */
        },
        payment_logic(param){
            external.payment_logic(param);
        },
        move_page(Num) {
            let move_link = "";
            if (Num == 0) {
                move_link = "/front_main";
            } else if (Num == 1) {
                move_link = "/";
            } else if (Num == 2) {
                move_link = "/barcode";
            } else if (Num == 3)  {
                move_link = "/price_list";
            } else if (Num == 4)  {
                move_link = "/mypage";
            }
            this.$router.push(move_link).catch(e => {});
            this.now_route = Num;
        },
        goHome(){
            var router = this.$router;
            this.check_items_status();
            this.now_route = 0;
            router.push('/front_main');
        }
    },
    computed: {
        get_now_route() {
            return this.now_route;
        },
        get_login_check() {
            return this.$store.getters.get_login_yn;
        },
        get_page_header_init(){
            return this.$store.getters.get_page_header_init;
        },
        time() {
            this.text_color = this.$store.state.my_color.text_color
            return `${this.date.toLocaleTimeString()}`
        },
        onClickApp() {
        },
        get_main_page_top_menu_code(){
            return this.$store.getters.get_main_page_top_menu_code;
        },
        change_store_check(){
            return this.$store.getters['getUser'].user_id
        },
        // 코드 추가 - 2020-12-23
        get_mobile_promotion_yn(){
            return this.$store.getters['get_mobile_promotion_yn'].value;
        }
    },
    watch: {
        get_now_route(idx) {
            let li_list = document.querySelectorAll('.bottom_menu_icon');
            li_list.forEach(e => {
                e.classList.remove('active');
            })
            li_list[idx].classList.add('active');
        },
        // 변화감지값
        get_login_check() {
            var user_data = this.$store.getters['getUser'];
            if (this.$store.getters.get_login_yn) {
                this.login_user = user_data;
                this.login_chk = 1;
                this.total_time = this.init_time;
                var store_info = this.$store.getters['getStoreInfo'];
                this.store_name = store_info.store_name;
                this.user_name = user_data.name;
            } else {
                this.login_chk = 0;
                // this.login_user.name = '비회원';
            }
            this.get_top_menu_list(this.$store.getters.get_main_page_top_menu_code);
        },
        get_page_header_init(){
            this.header_style = this.$store.getters.get_page_header_init;
            var temp_store_bg_image = this.$store.getters['getStoreInfo']['store_bg_img'];
            if(typeof temp_store_bg_image == 'undefined' || temp_store_bg_image == ''){
                temp_store_bg_image = '';
            }else{
                temp_store_bg_image = config.SYS_HOST+'/images/kiosk/bg/'+temp_store_bg_image;
            }
            this.store_bg_image = temp_store_bg_image;

            var temp_store_top_image = this.$store.getters['getStoreInfo']['store_top_img'];
            if(typeof temp_store_top_image == 'undefined' || temp_store_top_image == ''){
                temp_store_top_image = '';
            }else{
                temp_store_top_image = config.SYS_HOST+'/images/kiosk/top/'+temp_store_top_image;
            }
            this.store_top_image = temp_store_top_image;
        },
        get_main_page_top_menu_code(){
            var store_info = this.$store.getters['getStoreInfo'];
            this.store_name = store_info.store_name;
        },
        change_store_check(){
            let user = this.$store.getters['getUser'];
            this.user_id = user.user_id;
            this.user_name = user.name;
        },
        // 코드 추가 - 2020-12-23
        get_mobile_promotion_yn(){
            this.promotion_yn = this.$store.getters['get_mobile_promotion_yn'].value;
        }
    },
    mounted: function() {
        if (process.env.NODE_ENV == 'production') {
            this.$router.push('/');
        }
        this.$store.commit('set_reset_popup_type');
        let host = config.HOST;
        let css = 'default';
        let cssNameArr = ['common', 'front_main', 'tab', 'video-js',
            'popup', 'main_min', 'seat','reset', 'login', 'pay_min', 'mypage_min', 'barcode', 'swiper' /* 'main_min_video' */];
        for(name of cssNameArr){
            let style = document.createElement('link');
            style.type = "text/css";
            style.rel = "stylesheet";
            style.href = host+'/mobile/css/'+css+'/'+name+'.css';
            document.head.appendChild(style);
        }
    },
    updated() {
        if(this.$router.history.current.fullPath == '/front_main'){
            this.now_route = 0;
        }else if(this.$router.history.current.fullPath == '/'){
            this.now_route = 1;
        }else if(this.$router.history.current.fullPath == '/barcode'){
            this.now_route = 2;
        }else if(this.$router.history.current.fullPath == '/price_list'){
            this.now_route = 3;
        }else if(this.$router.history.current.fullPath == '/mypage'){
            this.now_route = 4;
        }else{
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue